import React from 'react';
import { Navbar } from 'react-bootstrap';
import Logo from '../../assets/campusconectado.svg';

export function HeaderLogin () {
  return (
    <Navbar className="headerLogin" bg="dark" variant="dark">
      <Navbar.Brand>
        <img src={Logo} height="40px" alt="" srcSet="" />
      </Navbar.Brand>
    </Navbar>
  );
}
